import React from 'react'

import { useHasMultipleReferralInvites } from '@/components/layouts/ReferralInviteLayout/hooks/useHasMultipleReferralInvites'
import { useClaimReferralModal } from '@/components/misc/ReferralDetails/hooks/useClaimReferralModal'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useCurrentUserOrFail } from '@/hooks/useCurrentUserOrFail'
import authService from '@/lib/services/authService'

const AlreadyLoggedInAsClientUserModal: React.FC = () => {
  const claimReferralModal = useClaimReferralModal()
  const currentUser = useCurrentUserOrFail()
  const hasMultipleInvites = useHasMultipleReferralInvites()

  return (
    <Dialog
      onHide={claimReferralModal.hide}
      open={claimReferralModal.isShowing}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Claim {hasMultipleInvites ? 'referrals' : 'referral'}
          </DialogTitle>
        </DialogHeader>

        <DialogBody>
          <p className="mb-4">
            You're currently logged in as a Compass portal user (
            <em>{currentUser.email}</em>). Please sign out from your current
            account, revisit this link and create a separate account (with a
            separate email address) to claim this referral.
          </p>

          <Button onClick={() => authService.logout()}>
            Click here to sign out
          </Button>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}

export default AlreadyLoggedInAsClientUserModal
